import { Camera } from "lucide-react";

// Galería de trabajos reales realizados por Multiservicios PS 24.
// Las fotos están alojadas en /app/frontend/public/galeria/
const ITEMS = [
  {
    src: "/galeria/img1.jpeg",
    tag: "Trabajo realizado #1",
    desc: "Baño con pared de piedra natural, microcemento y espejo LED",
  },
  {
    src: "/galeria/img3.jpeg",
    tag: "Trabajo realizado #2",
    desc: "Cocina con alicatado metro y pavimento de microcemento",
  },
  {
    src: "/galeria/img5.jpeg",
    tag: "Trabajo realizado #3",
    desc: "Ducha de obra con microcemento y piedra rústica",
  },
  {
    src: "/galeria/img2.jpeg",
    tag: "Trabajo realizado #4",
    desc: "Salón con paredes de piedra y vigas de madera restauradas",
  },
  {
    src: "/galeria/img4.jpeg",
    tag: "Trabajo realizado #5",
    desc: "Reforma de baño con alicatado metro blanco y mueble suspendido",
  },
];

export default function Gallery() {
  return (
    <section id="trabajos" className="bg-white scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Antes y después</div>
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
            Trabajos reales de Multiservicios PS 24
          </h2>
          <p className="text-slate-500 mt-3">
            Fotografías reales de reformas, baños, cocinas, alicatados, pavimentos de microcemento y trabajos de albañilería realizados por nuestro equipo.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className="group relative rounded-xl overflow-hidden border border-slate-200 aspect-[3/4] bg-slate-100"
            >
              <img
                src={it.src}
                alt={it.desc}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/95 to-transparent pt-10 pb-3 px-3 pointer-events-none">
                <span className="inline-block text-[10px] uppercase tracking-wider font-semibold px-2 py-1 rounded bg-[#004B87] text-white mb-1.5 shadow-md">
                  {it.tag}
                </span>
                <p className="text-xs md:text-sm leading-snug text-white font-medium">
                  {it.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 flex items-start gap-3 p-4 rounded-lg bg-slate-50 border border-slate-200 text-sm text-slate-600">
          <Camera className="w-4 h-4 text-[#004B87] shrink-0 mt-0.5" />
          <p>Todas las imágenes corresponden a trabajos reales realizados por Multiservicios PS 24. Más proyectos disponibles bajo petición y en nuestro Instagram <strong className="text-slate-900">@multiserviciosps24</strong>.</p>
        </div>
      </div>
    </section>
  );
}
